import { combineEpics }             from 'redux-observable';
import { applicationEpics }         from './Application';
import { userEpics }                from './User';
import { organizerEpics }           from './Organizer';
import { eventEpics }               from './Event';
import { eventTicketEpics }         from './EventTicket';
import { eventCategoryEpics }       from './EventCategory';
import { eventParentCategoryEpics } from './EventParentCategory';
import { locationEpics }            from './Location';
import { settingsEpics }            from './Settings';
import { invoiceEpics }             from './Invoice';
import { userTicketEpics }          from './UserTicket';
import { appUserEpics }             from './AppUser';
import { salesEpics }               from './Sales';
import { organisationInvoiceEpics } from './OrganisationInvoice';
import { employeeEpics }            from './Employee';

export const rootEpics = combineEpics(
  applicationEpics,
  userEpics,
  organizerEpics,
  eventEpics,
  eventTicketEpics,
  eventCategoryEpics,
  locationEpics,
  settingsEpics,
  invoiceEpics,
  userTicketEpics,
  salesEpics,
  eventParentCategoryEpics,
  appUserEpics,
  organisationInvoiceEpics,
  employeeEpics,
);
